import {
  LOAD_DEFAULT_TRANSLATION,
  LOAD_TRANSLATION,
  LOAD_TRANSLATION_FAIL,
  LOAD_TRANSLATION_SUCCESS,
  TranslationAction
} from './translation.actions';

export interface TranslationState {
  loaded: boolean;
  loadedInformal: boolean;
  loading: boolean;
  error: string | null;
}

export const initialState: TranslationState = {
  loaded: false,
  loadedInformal: false,
  loading: false,
  error: null
};

export function reducer(
  state: TranslationState = initialState,
  action: TranslationAction
): TranslationState {
  switch (action.type) {
    case LOAD_TRANSLATION: {
      return {
        ...state,
        loading: true
      };
    }

    case LOAD_TRANSLATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        loadedInformal: action.informal,
        error: null
      };
    }

    case LOAD_TRANSLATION_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case LOAD_DEFAULT_TRANSLATION: {
      return {
        ...state,
        loaded: true,
        error: null
      };
    }

    default: {
      return state;
    }
  }
}
